import React from 'react';
import { Link } from 'react-router-dom';
import { MapPinIcon, MailIcon, PhoneIcon } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/fuxK5gpC3KKbVyhBpnrWVa/Picture1.png';
export function Footer() {
  return <footer className="border-t border-steca-100 bg-steca-900 text-steca-100" data-id="element-16" data-mp="32pfgsfx1bq0a">
      <div className="mx-auto grid max-w-6xl gap-8 px-4 py-12 sm:px-6 md:grid-cols-4" data-id="element-17" data-mp="36qheutf7tw0o">
        <div className="md:col-span-2" data-id="element-18" data-mp="3uesczotj1hl9">
          <img src={LOGO_URL} alt="Steca Global Security" className="h-10 w-auto rounded bg-white px-2 py-1" data-id="element-19" data-mp="3uftkxkf8xnyr" />
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-steca-100/80" data-id="element-20" data-mp="3lf56wppurnlv">
            Steca Global Security provides high-security safekeeping, professional guard services,
            and secure escort and convoy protection across Dar es Salaam.
          </p>
        </div>
        <div data-id="element-21" data-mp="2ey0bce9yoskt">
          <h3 className="text-sm font-semibold uppercase tracking-wider text-white" data-id="element-22" data-mp="2eyjrbpg1x6w7">Company</h3>
          <ul className="mt-4 space-y-2 text-sm" data-id="element-23" data-mp="3l8qupznvcbpc">
            <li data-id="element-24" data-mp="3lbmttrbgd6fd"><Link to="/" className="hover:text-white" data-id="element-25" data-mp="3lbmvdvr3pehh">Home</Link></li>
            <li data-id="element-26" data-mp="3gbqy0fcwslaw"><Link to="/services" className="hover:text-white" data-id="element-27" data-mp="3gc0g7grppo61">Services</Link></li>
            <li data-id="element-28" data-mp="3v8rgds97n3wp"><Link to="/verify" className="hover:text-white" data-id="element-29" data-mp="3v8rl25k5ns31">Verify SKR</Link></li>
            <li data-id="element-30" data-mp="3q8dk17gz1iei"><Link to="/contact" className="hover:text-white" data-id="element-31" data-mp="3q8dih31bpace">Contact</Link></li>
          </ul>
        </div>
        <div data-id="element-32" data-mp="81yvyfozns2e">
          <h3 className="text-sm font-semibold uppercase tracking-wider text-white" data-id="element-33" data-mp="81pdrea6qp79">Contact</h3>
          <ul className="mt-4 space-y-3 text-sm text-steca-100/80" data-id="element-34" data-mp="335trjf5jnhj">
            <li className="flex items-start gap-2" data-id="element-35" data-mp="htd0x2zplk2x">
              <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-steca-300" data-id="element-36" data-mp="huwiqy10k36t" />
              Kinondoni, Dar es Salaam, Tanzania
            </li>
            <li className="flex items-center gap-2" data-id="element-37" data-mp="qt05tyrnd80q">
              <PhoneIcon className="h-4 w-4 shrink-0 text-steca-300" data-id="element-38" data-mp="qrf9q4poph0r" />
              Tel: +255 22 5612874 · Fax: +255 22 5612875
            </li>
            <li className="flex items-center gap-2" data-id="element-39" data-mp="tvmordarg8js">
              <PhoneIcon className="h-4 w-4 shrink-0 text-steca-300" data-id="element-40" data-mp="tt088o5w6ipf" />
              Cell: +255 745 79 73 95
            </li>
            <li className="flex items-center gap-2" data-id="element-41" data-mp="13tansffeg27r">
              <MailIcon className="h-4 w-4 shrink-0 text-steca-300" data-id="element-42" data-mp="13rpsgnl9gf8u" />
              info@stecaglobalsecurity.com
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10" data-id="element-43" data-mp="1cmdw69b6tovj">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-steca-100/70 sm:flex-row sm:px-6" data-id="element-44" data-mp="1cnozy94muwmn">
          <p data-id="element-45" data-mp="1mjikaeolfuez">© {new Date().getFullYear()} Steca Global Security-International. All rights reserved.</p>
          <p data-id="element-46" data-mp="1rj4z2sk2lipw">Licensed &amp; insured custodial services.</p>
        </div>
      </div>
    </footer>;
}